import Button from '@material-ui/core/Button';
import {Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';

import {ModalNext} from 'src/componentsNext/ModalNext';
import {extendedTypography} from 'src/themes/themeNext/extendedTypography';

export const useStyles = makeStyles(theme => ({
  text: {
    ...extendedTypography.body2RegularDesktop,

    [theme.breakpoints.down('sm')]: {
      ...extendedTypography.body2RegularMobile
    }
  },
  textMargin: {
    marginBottom: theme.spacing(1)
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4)
  }
}));

export const DisconnectDiscordModal = ({open, onClose, onDisconnect}) => {
  const classes = useStyles();

  const handleDisconnect = () => {
    onDisconnect();
    onClose();
  };

  return (
    <ModalNext
      centerVertical
      open={open}
      onClose={onClose}
      title='Disconnect Discord?'
      maxWidth='md'
    >
      <div>
        <Typography classes={{root: clsx(classes.text, classes.textMargin)}}>
          Disconnecting Discord will remove the link between your account and
          Discord.
        </Typography>
        <Typography classes={{root: classes.text}}>
          Are you sure you want to proceed?
        </Typography>
        <div className={classes.actions}>
          <Button
            fullWidth
            variant='outlined'
            color='primary'
            onClick={onClose}
            size='small'
          >
            Cancel
          </Button>
          <Button
            fullWidth
            size='small'
            variant='contained'
            color='secondary'
            onClick={handleDisconnect}
          >
            Disconnect
          </Button>
        </div>
      </div>
    </ModalNext>
  );
};
